function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { loadModule, logger, fill, isThenable } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';

// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])

var OPERATIONS = ['aggregate',
// aggregate(pipeline, options, callback)
'bulkWrite',
// bulkWrite(operations, options, callback)
'countDocuments',
// countDocuments(query, options, callback)
'createIndex',
// createIndex(fieldOrSpec, options, callback)
'createIndexes',
// createIndexes(indexSpecs, options, callback)
'deleteMany',
// deleteMany(filter, options, callback)
'deleteOne',
// deleteOne(filter, options, callback)
'distinct',
// distinct(key, query, options, callback)
'drop',
// drop(options, callback)
'dropIndex',
// dropIndex(indexName, options, callback)
'dropIndexes',
// dropIndexes(options, callback)
'estimatedDocumentCount',
// estimatedDocumentCount(options, callback)
'find',
// find(query, options, callback)
'findOne',
// findOne(query, options, callback)
'findOneAndDelete',
// findOneAndDelete(filter, options, callback)
'findOneAndReplace',
// findOneAndReplace(filter, replacement, options, callback)
'findOneAndUpdate',
// findOneAndUpdate(filter, update, options, callback)
'indexes',
// indexes(options, callback)
'indexExists',
// indexExists(indexes, options, callback)
'indexInformation',
// indexInformation(options, callback)
'initializeOrderedBulkOp',
// initializeOrderedBulkOp(options, callback)
'insertMany',
// insertMany(docs, options, callback)
'insertOne',
// insertOne(doc, options, callback)
'isCapped',
// isCapped(options, callback)
'mapReduce',
// mapReduce(map, reduce, options, callback)
'options',
// options(options, callback)
'parallelCollectionScan',
// parallelCollectionScan(options, callback)
'rename',
// rename(newName, options, callback)
'replaceOne',
// replaceOne(filter, doc, options, callback)
'stats',
// stats(options, callback)
'updateMany',
// updateMany(filter, update, options, callback)
'updateOne' // updateOne(filter, update, options, callback)
];

// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var OPERATION_SIGNATURES = {
  // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
  // see https://github.com/getsentry/sentry-javascript/pull/3102
  bulkWrite: ['operations'],
  countDocuments: ['query'],
  createIndex: ['fieldOrSpec'],
  createIndexes: ['indexSpecs'],
  deleteMany: ['filter'],
  deleteOne: ['filter'],
  distinct: ['key', 'query'],
  dropIndex: ['indexName'],
  find: ['query'],
  findOne: ['query'],
  findOneAndDelete: ['filter'],
  findOneAndReplace: ['filter', 'replacement'],
  findOneAndUpdate: ['filter', 'update'],
  indexExists: ['indexes'],
  insertMany: ['docs'],
  insertOne: ['doc'],
  mapReduce: ['map', 'reduce'],
  rename: ['newName'],
  replaceOne: ['filter', 'doc'],
  updateMany: ['filter', 'update'],
  updateOne: ['filter', 'update']
};
function isCursor(maybeCursor) {
  return maybeCursor && _typeof(maybeCursor) === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}

/** Tracing integration for mongo package */
var Mongo = /*#__PURE__*/function () {
  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
  function Mongo() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Mongo);
    this.name = Mongo.id;
    this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
    this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
    this._useMongoose = !!options.useMongoose;
  }

  /** @inheritdoc */
  _createClass(Mongo, [{
    key: "loadDependency",
    value: function loadDependency() {
      var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
      return this._module = this._module || loadModule(moduleName);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Mongo Integration is skipped because of instrumenter configuration.');
        return;
      }
      var pkg = this.loadDependency();
      if (!pkg) {
        var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error("Mongo Integration was unable to require `".concat(moduleName, "` package."));
        return;
      }
      this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }

    /**
     * Patches original collection methods
     */
  }, {
    key: "_instrumentOperations",
    value: function _instrumentOperations(collection, operations, getCurrentHub) {
      var _this = this;
      operations.forEach(function (operation) {
        return _this._patchOperation(collection, operation, getCurrentHub);
      });
    }

    /**
     * Patches original collection to utilize our tracing functionality
     */
  }, {
    key: "_patchOperation",
    value: function _patchOperation(collection, operation, getCurrentHub) {
      if (!(operation in collection.prototype)) return;
      var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
      fill(collection.prototype, operation, function (orig) {
        return function () {
          var _this2 = this;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var lastArg = args[args.length - 1];
          var scope = getCurrentHub().getScope();
          var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
            return _2.getSpan;
          }, 'call', function (_3) {
            return _3();
          }]);

          // Check if the operation was passed a callback. (mapReduce requires a different check, as
          // its (non-callback) arguments can also be functions.)
          if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
            var _span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
              return _4.startChild;
            }, 'call', function (_5) {
              return _5(getSpanContext(_this2, operation, args));
            }]);
            var maybePromiseOrCursor = orig.call.apply(orig, [this].concat(args));
            if (isThenable(maybePromiseOrCursor)) {
              return maybePromiseOrCursor.then(function (res) {
                _optionalChain([_span, 'optionalAccess', function (_6) {
                  return _6.finish;
                }, 'call', function (_7) {
                  return _7();
                }]);
                return res;
              });
            }
            // If the operation returns a Cursor
            // we need to attach a listener to it to finish the span when the cursor is closed.
            else if (isCursor(maybePromiseOrCursor)) {
              var cursor = maybePromiseOrCursor;
              try {
                cursor.once('close', function () {
                  _optionalChain([_span, 'optionalAccess', function (_8) {
                    return _8.finish;
                  }, 'call', function (_9) {
                    return _9();
                  }]);
                });
              } catch (e) {
                // If the cursor is already closed, `once` will throw an error. In that case, we can
                // finish the span immediately.
                _optionalChain([_span, 'optionalAccess', function (_10) {
                  return _10.finish;
                }, 'call', function (_11) {
                  return _11();
                }]);
              }
              return cursor;
            } else {
              _optionalChain([_span, 'optionalAccess', function (_12) {
                return _12.finish;
              }, 'call', function (_13) {
                return _13();
              }]);
              return maybePromiseOrCursor;
            }
          }
          var span = _optionalChain([parentSpan, 'optionalAccess', function (_14) {
            return _14.startChild;
          }, 'call', function (_15) {
            return _15(getSpanContext(_this2, operation, args.slice(0, -1)));
          }]);
          return orig.call.apply(orig, [this].concat(_toConsumableArray(args.slice(0, -1)), [function (err, result) {
            _optionalChain([span, 'optionalAccess', function (_16) {
              return _16.finish;
            }, 'call', function (_17) {
              return _17();
            }]);
            lastArg(err, result);
          }]));
        };
      });
    }

    /**
     * Form a SpanContext based on the user input to a given operation.
     */
  }, {
    key: "_getSpanContextFromOperationArguments",
    value: function _getSpanContextFromOperationArguments(collection, operation, args) {
      var data = {
        'db.system': 'mongodb',
        'db.name': collection.dbName,
        'db.operation': operation,
        'db.mongodb.collection': collection.collectionName
      };
      var spanContext = {
        op: 'db',
        // TODO v8: Use `${collection.collectionName}.${operation}`
        origin: 'auto.db.mongo',
        description: operation,
        data: data
      };

      // If the operation takes no arguments besides `options` and `callback`, or if argument
      // collection is disabled for this operation, just return early.
      var signature = OPERATION_SIGNATURES[operation];
      var shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
      if (!signature || !shouldDescribe) {
        return spanContext;
      }
      try {
        // Special case for `mapReduce`, as the only one accepting functions as arguments.
        if (operation === 'mapReduce') {
          var _args = _slicedToArray(args, 2),
            map = _args[0],
            reduce = _args[1];
          data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
          data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
        } else {
          for (var i = 0; i < signature.length; i++) {
            data["db.mongodb.".concat(signature[i])] = JSON.stringify(args[i]);
          }
        }
      } catch (_oO) {
        // no-empty
      }
      return spanContext;
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Mongo';
    }
  }]);
  return Mongo;
}();
Mongo.__initStatic();
export { Mongo };